export default __webpack_public_path__ + "static/media/tenth.19d50354.png";